module.exports = __webpack_public_path__ + "staticcomp/img/content_2.da368b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/5/content_2.jpg
// module id = 6X+O
// module chunks = 39